import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ManagerReportsRoutingModule } from './manager-reports-routing.module';
import { ManagerReportsComponent } from './manager-reports.component';
import { DropDownModule } from '../A2-utils/drop-down/drop-down.module';
import { RolesService } from '../roles/roles.service';
import { UsersService } from '../users/users.service';
import { DirectivesModule } from 'app/directives/directives.module';
import { ManagerReportsService } from './manager-reports.service';
import { ReportHistoryModule } from '../A2-utils/report-history/report-history.module';
import { ReportTripsComponent } from './report-trips/report-trips.component';
import { ReportDispatchComponent } from './report-dispatch/report-dispatch.component';
import { ReportPayorsComponent } from './report-payors/report-payors.component';
import {ReportsModule} from '../reports/reports.module';
import { TacmsErrorReportComponent } from './tacms-error-report/tacms-error-report.component';
import { DuplicateModifiersReportComponent } from './duplicate-modifiers-report/duplicate-modifiers-report.component';
import {Trip2ThemeModule} from '../../trip2-theme/trip2-theme.module';
import { MyDateRangePickerModule } from 'mydaterangepicker';
import { MyDatePickerModule } from 'mydatepicker';
import {FormsModule} from '@angular/forms';
import { LogisticareUtsReportComponent } from './logisticare-uts-report/logisticare-uts-report.component';
import { ZuniReportComponent } from './zuni-report/zuni-report.component';
import { PayorDateRangeReportComponent } from './components/payor-date-range-report/payor-date-range-report.component';
import { NgMultiSelectDropDownModule } from 'ng-multiselect-dropdown';

@NgModule({
  imports: [
    CommonModule,
    ManagerReportsRoutingModule,
    DropDownModule,
    DirectivesModule,
    ReportHistoryModule,
    ReportsModule,
    Trip2ThemeModule,
    MyDateRangePickerModule,
    MyDatePickerModule,
    FormsModule,
    NgMultiSelectDropDownModule.forRoot()
  ],
  declarations: [ManagerReportsComponent, ReportTripsComponent, ReportDispatchComponent, ReportPayorsComponent, TacmsErrorReportComponent, DuplicateModifiersReportComponent, LogisticareUtsReportComponent, ZuniReportComponent,  PayorDateRangeReportComponent],
  providers: [RolesService, UsersService, ManagerReportsService],
  exports: [ReportTripsComponent]
})
export class ManagerReportsModule { }




// WEBPACK FOOTER //
// ./src/app/pages/manager-reports/manager-reports.module.ts